import { ApolloProvider } from '@apollo/client';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import '../wdyr';
import './i18n';
import './layout/styles/global.scss';
import client from 'api/environment';
import Loader from 'atoms/Loader/Loader';
import FaviconPng from 'images/favicon192.png';
import { watchActiveOrganization } from 'utils/activeOrganization';
import MutationStateProvider from 'utils/MutationStateProvider';
import WebSocketManager from './hooks/WebSocketManager';
import keycloak, { initOptions } from './keycloak';
import App from './Routs';
import store from './store';
const tokenSaver = (tokens) => {
    var _a, _b, _c;
    const previousToken = localStorage.getItem('token');
    const isTokenRefresh = previousToken && previousToken !== tokens.token;
    localStorage.setItem('idToken', (_a = tokens.idToken) !== null && _a !== void 0 ? _a : '');
    localStorage.setItem('refreshToken', (_b = tokens.refreshToken) !== null && _b !== void 0 ? _b : '');
    localStorage.setItem('token', (_c = tokens.token) !== null && _c !== void 0 ? _c : '');
    if (isTokenRefresh) {
        // eslint-disable-next-line no-console
        console.log('🔄 Token refreshed, reconnecting WebSocket with new token...');
        const wsManager = WebSocketManager.getInstance();
        wsManager.disconnect();
    }
};
const onEvent = (event) => {
    if (event === 'onAuthSuccess') {
        keycloak.loadUserProfile().then((keycloakProfile) => {
            localStorage.setItem('userProfile', JSON.stringify(keycloakProfile));
        });
    }
};
// A switch in another tab reloads this one, so all tabs stay on the same organization.
watchActiveOrganization();
const container = document.getElementById('root');
createRoot(container).render(React.createElement(ReactKeycloakProvider, { authClient: keycloak, initOptions: initOptions, onTokens: tokenSaver, onEvent: onEvent, LoadingComponent: React.createElement(Loader, { fullViewport: true }) },
    React.createElement(Helmet, null,
        React.createElement("title", null, "Fashion App"),
        React.createElement("meta", { property: "og:title", content: "Fashion App" }),
        React.createElement("link", { rel: "icon", href: FaviconPng })),
    React.createElement(ApolloProvider, { client: client },
        React.createElement(Provider, { store: store },
            React.createElement(Router, { basename: process.env.MAIN_PATH },
                React.createElement(MutationStateProvider, null,
                    React.createElement(App, null)))))));
